import axios from 'axios'

import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { FileUploadDatasource } from '../infra/datasources/fileUploadDatasource'

const axiosInstance = axios.create()

export const fileUploadDatasourceAdapter: FileUploadDatasource = {
  async uploadFile({ file, url, abortSignal, onUploadProgress }) {
    const res = await HTTPExceptionInterceptor(
      await axiosInstance.put(url, file, {
        signal: abortSignal,
        headers: {
          'content-type': file.type
        },
        onUploadProgress: ({ loaded, total }) =>
          onUploadProgress?.({ loaded, total: total ?? file.size })
      })
    )

    const etag = res.headers.get('etag')?.replaceAll('"', '')
    return { etag: etag ?? '' }
  },

  async completeMultipartPresignUrl({
    fileName,
    folderName,
    partETags,
    uploadId
  }) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/complete-multipart`,
          httpTokenInterceptor({
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ fileName, folderName, partETags, uploadId })
          })
        )
      )
    )
  },

  async presignUrl({ contentType, fileName, folderName, number }) {
    const res = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/presigned-url`,
          httpTokenInterceptor({
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              contentType,
              fileName,
              folderName,
              number: number || 1
            })
          })
        )
      )
    )
    const data = await res.json()
    return data
  }
}
